import React from 'react';

// La navegación de SG-SST ahora vive en el menú (cinta superior / sidebar),
// con un botón por cada área. Este componente se deja vacío para no duplicar
// la barra de pestañas dentro de cada página del módulo.
export default function SgsstTabs() {
  return null;
}
